import { clientMetadataService } from '../../helpers/services/clientMetadata.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  details: {},
  status: { detail: true, save: true },
}

export const CLIENT_METADATA_MODULE = 'clientMetadata'

export const GET_CLIENT_METADATA = 'getClientMetadata'
export const UPSERT_CLIENT_METADATA = 'upsertClientMetadata'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const DETAIL_SUCCESS = 'detailSuccess'

export const actions = {
  [GET_CLIENT_METADATA]({ commit }, { accountNo }) {
    commit(REQUESTING, 'detail')
    return clientMetadataService.getClientMetadata(accountNo).then((r) => {
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [UPSERT_CLIENT_METADATA]({ commit }, { data }) {
    commit(REQUESTING, 'save')
    return clientMetadataService.upsertClientMetadata(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.client')]))
      commit(DETAIL_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [DETAIL_SUCCESS](state, data) { state.details = data.data || {} },
  [FAILURE](state) { state.status = { detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { detail: true, save: true } },
}
